import React, { Fragment, useState } from 'react';
import {Button} from '@progress/kendo-react-buttons';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';

import filterIds from '../filter_ids';

const FilterItemDatePicker = ({addFilterParam, removeFilterParam }) => {

    const [displayDateRange, setDisplayDateRange] = useState(false);
    const [customDateRange, setCustomDateRange] = useState({ start: null, end: null});

    const removeDatesFilter = (silently=false) => {
        const { start, end } = customDateRange;
        if(start && end) {
          const startDate = start.toLocaleDateString('en-US');
          const endDate = end.toLocaleDateString('en-US');
    
        removeFilterParam(filterIds.DATE, startDate + '-' + endDate, silently);
        setCustomDateRange({
              start: null,
              end: null
            }
          );
        }
      };
    
    const handleDatePickerButtonClick = () => {
        setDisplayDateRange(!displayDateRange);
      };
    
    const handleDatePickerSelection = (event) => {
        const value = event.target.value;
        if (customDateRange.start && customDateRange.end) removeDatesFilter(true);
        setCustomDateRange(value);
      };
    
    const handleDatePickerClosed = () => {
        const { start, end } = customDateRange;
        if(start && end) {
          const startDate = start.toLocaleDateString('en-US');
          const endDate = end.toLocaleDateString('en-US');
    
          addFilterParam(filterIds.DATE, startDate + '-' + endDate);
        }
      };
    
    const handleClearDateClick = () => removeDatesFilter(false);

    const dateInputSettings = {
      format: "dd MMM yyyy"
    };

    return (
      <div className="date-filter-container">
        <Button primary onClick={handleDatePickerButtonClick}>Custom</Button>
        { displayDateRange &&
          <Fragment>
            <DateRangePicker value={customDateRange}
                           startDateInputSettings={dateInputSettings}
                           endDateInputSettings={dateInputSettings}
                           popupSettings={{ onClose: handleDatePickerClosed }}
                           onChange={handleDatePickerSelection}/>
            <button onClick={handleClearDateClick} className="button-link" style={{ marginTop: "5px" }}>Clear dates</button>
          </Fragment>
        }
      </div>
    );

  };

  export default FilterItemDatePicker;